<template>
    <v-container>
        <v-layout>
            <v-flex md12>
                <v-card>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">Evaluación docente</h3>
                        </div>
                    </v-card-title>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  export default {
    name: 'EvaluacionDocentePage'
  }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/pages/EvaluacionDocentePage.vue